import { RouteRecordRaw } from 'vue-router';
import { ViewRejectedPage } from '@/pages/registry-management';

export const routeName = 'GestaoRegistrosReprovadoVisualizar';

export const route: RouteRecordRaw = {
  path: 'gestao-registros/reprovados/:id',
  name: routeName,
  component: ViewRejectedPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Registro reprovado',
    dynamicBreadcrumb: true,
    breadcrumbTrail: [
      { name: 'Gestão de Registros', path: '/gestao-registros' },
      { name: 'Modelos', path: '/gestao-registros/modelos' },
      { name: 'Reprovados', path: '/gestao-registros/modelos?tab=reprovados' },
      { name: 'Registro reprovado' },
    ],
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
